import { Certificate } from "@/atomic-components/organisms/forms/edit-forms/ssl/ssl-certificate-edit";

export class OrganViewPanelSslCertificateDetailController {
    public certificate: Certificate;

    public get isPaidUntilBiggerThanEnddate(): boolean {
        return Date.parse(this.certificate?.endDate) < Date.parse(this.certificate?.paidUntil);
    }
}

export class OrganViewPanelSslCertificateDetailComponent implements ng.IComponentOptions {
    public bindings = {
        certificate: '<certificate'
    };
    public controller = OrganViewPanelSslCertificateDetailController;
    public controllerAs = '$viewPanelOrgan';
    public template = require('./ssl-certificate-detail-view.html');
}
